/*=========================================================================================
  File Name: module-import-getters.js
  Description: Supplier Module Actions
  ----------------------------------------------------------------------------------------
  Project: MISA InvoiceBots
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/
import { MSEnum } from '@/common/enumeration';

export default {
	/**
	 * Lấy danh sách cột nhập khẩu
	 * @author dqduy 13.08.2024
	 * @param {*} state
	 */
	ImportColumns(state) {
		return state.ImportColumns;
	},

	GetLanguageImport(state) {
		return state.Lang;
	},

	ImportColumnsNoDownloadInvoice(state) {
		return state.ImportColumnsNoDownloadInvoice;
	},

	GetImportColumnsByType(state) {
		return function(type) {
			let columns = [];
			switch (type) {
				case MSEnum.ImportType.Supplier:
					return state.ImportColumns;
				case MSEnum.ImportType.SupplierNoDownloadInvoice:
					return state.ImportColumnsNoDownloadInvoice;
				default:
					return [];
			}
		};
	}
};
